import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"

import { withFavouritesConfig } from "../config/FavouriteConfigProvider"
import { addNewObject } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"

const FavouriteSharer = ({ favourite, show, onHide, getText, user_list = [] }) => {
  const [selectedUserIDs, setSelectedUserIDs] = useState([])
  const [selectedUserNames, setSelectedUserNames] = useState([])
  const [error, setError] = useState(null)
  const [disabled, setDisabled] = useState(false)
  const [queryString, setQueryString] = useState("")
  const [filteredUsers, setFilteredUsers] = useState([])

  useEffect(() => {
    setFilteredUsers(user_list)
  }, [user_list])

  useEffect(() => {
    setSelectedUserNames(user_list.filter((u) => selectedUserIDs.includes(u.id)).map((u) => u.username))
  }, [selectedUserIDs])

  const onFilterUpdate = (ev) => {
    setQueryString(ev.target.value)
    const value = (ev.target.value || "").toLowerCase()
    if (value !== "") {
      setFilteredUsers(
        user_list.filter((u) =>
          ["first_name", "last_name", "email"]
            .map((param) => (u?.[param] || "").toLowerCase().includes(value))
            .some((match) => match),
        ),
      )
    } else {
      setFilteredUsers(user_list)
    }
  }

  const onCheckboxClicked = (ev, user) => {
    setError(null)
    if (ev.target.checked && !selectedUserIDs.includes(user.id)) {
      setSelectedUserIDs([...selectedUserIDs, user.id])
    } else if (!ev.target.checked && selectedUserIDs.includes(user.id)) {
      setSelectedUserIDs(selectedUserIDs.filter((id) => id !== user.id))
    }
  }

  const onSubmit = () => {
    setDisabled(true)

    let url
    if (favourite.runs) {
      url = `/users/favourites/runreactors/${favourite.id}/copy/`
    } else if (favourite.graphConfigs) {
      url = `/users/favourites/graphlayouts/${favourite.id}/copy/`
    } else {
      setError(getText("favourites.error.invalid.type", "Favourite Type Not Recognized"))
      return
    }

    addNewObject(
      url,
      {
        users: selectedUserIDs,
      },
      true,
    )
      .then(() => {
        setError(null)
        onHide()
      })
      .catch((e) => {
        setDisabled(false)
        logToServer(`Couldn't share favourite: ${e.statusText}`)
        e.text().then((err) => {
          logToServer(err)
          try {
            err = JSON.parse(err)
          } catch (e) {}
          setError(err)
        })
      })
  }

  return (
    <Modal size={"lg"} dialogClassName={"definitions-modal"} show={show} onHide={onHide} backdrop={"static"}>
      <Modal.Header closeButton>
        <Modal.Title>{`${getText("general.share", "Share Favourite")}: ${favourite.name}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <div className={"error-message"}>
            {(
              error?.message || getText("favourites.error.sharing.msg", "Error! Unable to share favourite...")
            ).toString()}
          </div>
        )}
        <div style={{ marginBottom: "10px" }}>
          <span>{getText("general.filter", "Filter")}</span>:
          <input
            id={"user-filter"}
            className={"form-control form-control-sm"}
            type={"text"}
            value={queryString}
            onChange={onFilterUpdate}
          />
        </div>
        {selectedUserNames.length > 0 && (
          <div style={{ marginBottom: "10px" }}>
            <span>{getText("general.selected", "Selected")}</span>
            :&nbsp;
            {selectedUserNames.join(", ")}
          </div>
        )}
        <div style={{ maxHeight: "400px", overflowY: "scroll" }}>
          <table className={"table table-compact table-striped"}>
            <thead>
              <tr>
                <th />
                <th className={"text-center"}>
                  {getText("administration.user-management.first_name", "First Name")}
                </th>
                <th className={"text-center"}>
                  {getText("administration.user-management.last_name", "Last Name")}
                </th>
                <th className={"text-center"}>{getText("general.email", "Email Address")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, i) => (
                <tr key={i}>
                  <td>
                    <input
                      type={"checkbox"}
                      checked={selectedUserIDs.includes(user.id)}
                      onChange={(ev) => onCheckboxClicked(ev, user)}
                    />
                  </td>
                  {["first_name", "last_name", "email"].map((param) => (
                    <td key={`${param}_${i}`} className={"text-center"}>
                      {user[param]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant={"outline-primary"}>
          {getText("general.closeButton", "Close")}
        </Button>
        <Button onClick={onSubmit} variant={"primary"} disabled={selectedUserIDs.length === 0 || disabled}>
          {getText("general.share", "Share")}&nbsp;
          <span className={"fa fa-paper-plane text_white"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default withFavouritesConfig(FavouriteSharer)
